module.exports = __webpack_public_path__ + "media/images/premium/premium/Property 1=plan-point-cbc03de8577fd0df2ec2f52815be72c1.svg";